export default __webpack_public_path__ + "static/media/home-travel-agency-destination-img04.22437591.jpg";